<template>
  <div class="page-filter">
    <header>
      <h4>{{ title }} Permissão</h4>
    </header>
    <form method="POST">
      <div class="row nop nom">
        <div class="form-group col-md-4">
          <input-control type="text" placeholder="Nome" v-model="nome" />
        </div>
        <div class="form-group col-md-4">
          <select-control type="text" placeholder="Setor" v-model="setor" :options="setores" />
        </div>
      </div>

      <div class="list-track" v-if="criarID != null">
        <div class="lists">
          <div>
            <header>
              <p>{{ listRoles.length }} permissões disponíveis</p>
              <a href="#" class="btn btn-secondary btn-small" @click.prevent="addAll">+ tudo</a>
            </header>
            <card :listed="false" :boxed="false">
              <div class="search">
                <input-control placeholder="Buscar permissão..." v-model="searchRoleQuery" @keyup="filterList('roles')" search preventSearchButton />
              </div>
              <div class="list-selector" v-if="listRoles.length">
                <ul>
                  <li v-for="item in listRoles" :key="item.id" @click="addItem(item)" class="noselect">
                    {{ item.name }}
                  </li>
                </ul>
              </div>
            </card>
          </div>

          <span>
            <fa :icon="['far', 'arrow-right-arrow-left']" />
          </span>

          <div>
            <header>
              <p>{{ listRolesSelected.length }} selecionadas</p>
              <a href="#" class="btn btn-secondary btn-small" @click.prevent="removeAll">− tudo</a>
            </header>
            <card :listed="false" :boxed="false">
              <div class="search">
                <input-control placeholder="Buscar selecionadas..." v-model="searchSelectedQuery" @keyup="filterList('selected')" search preventSearchButton />
              </div>
              <div class="list-selector" v-if="listRolesSelected.length">
                <ul>
                  <li v-for="item in listRolesSelected" :key="item.id" @click="removeItem(item)" class="noselect selected-item">
                    <span>{{ item.name }}</span>
                    <div v-if="item.home != null" class="addToHome" @click.stop="addToHome(item)" :class="{ selected: isSelected(item.id) }">
                      <div>
                        <span>{{ isSelected(item.id) ? 'Remover da home' : 'Adicionar à home' }}</span>
                        <fa :icon="['far','house']" />
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
              <div v-else class="emptyList">
                <div>
                  <fa :icon="['fas', 'square-dashed-circle-plus']" class="ic" />
                  <h5>Selecione itens na lista ao lado</h5>
                </div>
              </div>
            </card>
          </div>
        </div>
      </div>

      <div class="form-actions row save">
        <a href="#" class="btn btn-primary" @click.prevent="saveFuncao" v-if="criarID === null">Salvar</a>
        <a href="#" class="btn btn-primary" @click.prevent="editFuncao" v-else>Salvar</a>
        <a href="#" class="btn btn-primary" @click.prevent="close">Cancelar</a>
      </div>
    </form>
  </div>
</template>

<script>
import axios from 'axios'
import authHeader from '../../../services/auth-header'

export default {
  name: "criarFuncoes",
  props: {
    criarID: { type: [Number, String, Object], default: null }
  },
  data () {
    return {
      title: null,
      id: null,
      nome: null,
      setor: null,
      home_url: null,
      originalListRoles: [],
      originalListRolesSelected: [],
      urls_home: [],
      setores: [],
      listRolesSelected: [],
      listRoles: [],
      searchRoleQuery: '',
      searchSelectedQuery: '',
    }
  },
  watch: {
    criarID (newVal) {
      this.id = newVal.idFuncao
      this.nome = newVal.nome
      this.setor = newVal.idSetor
      this.home_url = newVal.home_url
      this.listRolesSelected = []
      this.listRoles = []
      this.getAllPermissionsFromFuncao()
    }
  },
  mounted () {
    setTimeout(() => {
      this.getSetores()
      this.title = this.criarID === null ? "Criar" : "Editar"
      this.criarID != null ? this.getAllPermissionsFromFuncao() : this.getAllPermissions()
    }, 100)
  },
  methods: {
    close () {
      this.$emit('close', '')
    },
    getSetores () {
      axios.get(process.env.VUE_APP_API_URL + 'auth/getlistasetores', { headers: authHeader() })
      .then(response => {
        this.setores = response.data.map(s => ({ label: s['descricao'], value: s['idSetor'] }))
      })
    },
    getAllPermissionsFromFuncao () {
      axios.get(process.env.VUE_APP_API_URL + 'auth/allpermissionsfromfuncao/' + this.id, { headers: authHeader() })
      .then(response => {
        this.listRolesSelected = response.data.map(item => {
          if ((item.angular === 1 && item.externo === 1 && item.router_link == '0') &&
              (item.numeroDashboard === null || item.nome_modulo === null)) {
            item.home = null
          }
          return item
        })
        this.originalListRolesSelected = [...this.listRolesSelected]
        this.getAllPermissions()

      })
    },
    getAllPermissions () {
      axios.get(process.env.VUE_APP_API_URL + 'auth/getallpermissions', { headers: authHeader() })
      .then(response => {
        this.listRoles = response.data.filter(item => {
          return !this.listRolesSelected.find(i => i.id == item.id)
        }).map(item => ({
          name: item.name,
          id: item.id,
          home: 0
        }))
        this.originalListRoles = [...this.listRoles]
      })
    },
    addToHome (el) {
      this.listRolesSelected.forEach(k => {
        if (k.id === el.id) k.home = k.home ? 0 : 1
      })
    },
    isSelected (el) {
      return this.listRolesSelected.some(k => k.id == el && k.home)
    },
    addItem (item) {
      if (!this.listRolesSelected.find(i => i.id === item.id)) {
        this.listRolesSelected.push(item)
        this.listRoles = this.listRoles.filter(i => i.id !== item.id)
      }
    },
    removeItem (item) {
      if (!this.listRoles.find(i => i.id === item.id)) {
        this.listRoles.push(item)
        this.listRolesSelected = this.listRolesSelected.filter(i => i.id !== item.id)
      }
    },
    addAll () {
      this.listRolesSelected = [...this.listRolesSelected, ...this.listRoles]
      this.listRoles = []
    },
    removeAll () {
      this.listRoles = [...this.listRoles, ...this.listRolesSelected]
      this.listRolesSelected = []
    },
    filterList(type) {
      const query = (type === 'roles' ? this.searchRoleQuery : this.searchSelectedQuery).toLowerCase()

      if (type === 'roles') {
        this.listRoles = this.originalListRoles.filter(item =>
          item.name.toLowerCase().includes(query)
        )
      } else {
        this.listRolesSelected = this.originalListRolesSelected.filter(item =>
          item.name.toLowerCase().includes(query)
        )
      }
    }
,
    saveFuncao () {
      window.spinner.emit('open')
      axios.post(process.env.VUE_APP_API_URL + 'funcao', {
        nome: this.nome,
        home_url: this.home_url,
        idSetor: this.setor
      }, { headers: authHeader() })
      .then(response => {
        this.close()
        window.toaster.emit('open', { style: "success", message: "Função criada com sucesso." })
        this.$emit('updateParentList', '')
        return response.data
      }).finally(() => window.spinner.emit('close'))
    },
    editFuncao () {
      window.spinner.emit('open')
      axios.put(process.env.VUE_APP_API_URL + 'funcao/' + this.id, {
        nome: this.nome,
        idSetor: this.setor,
        idFuncao: this.id,
        home_url: this.home_url,
        listRolesSelected: this.listRolesSelected
      }, { headers: authHeader() })
      .then(response => {
        this.close()
        window.toaster.emit('open', { style: "success", message: "Função editada com sucesso." })
        this.$emit('updateParentList', '')
        return response.data
      }).finally(() => window.spinner.emit('close'))
    }
  }
}
</script>

<style lang="scss" scoped>

.save{
  margin-top: 5rem;
}

header{
  display: flex;
  margin-left: 2rem;
  margin-top: 2rem;
}

.list-track {
  width: 100%;
  display: flex;
  justify-content: center;
  .lists {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 2rem;
    width: 95%;

    >div {
      flex: 1;
      display: flex;
      gap: 1rem;
      flex-direction: column;
      height: 75vh;
      min-height: 400px;
      background: #fff;
      border-radius: 10px;
      padding: 1rem;
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
    }

    header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      text-align: center;
      p {
        margin: 0;
        font-weight: bold;
      }
    }

    .search {
      margin-bottom: 0.75rem;
    }

    .list-selector {
      flex: 1;
      max-height: 100%;
      overflow-y: auto;
      padding-right: 4px;
    }

    ul {
      list-style: none;
      padding: 0;
      margin: 0;
      max-height: 26rem;

      li {
        margin: 6px;
        padding: 0.75rem 1rem;
        margin-bottom: 6px;
        background: #f8f8f8;
        border-radius: 6px;
        transition: background 0.2s ease;
        cursor: pointer;
        position: relative;
        min-height: 48px;

        &:hover {
          background: #efefef;
        }

        &.selected-item {
          display: flex;
          justify-content: space-between;
          align-items: center;

          .addToHome {
            position: relative;
            display: flex;
            align-items: center;

            > div {
              display: flex;
              align-items: center;
              gap: 6px;
              font-size: 14px;
              color: #888;
              transition: 0.3s ease;
            }

            &.selected > div {
              color: #1abc9c;
            }

            &:hover > div {
              color: #16a085;
            }
          }
        }
      }
    }
  }

  span {
    display: flex;
    align-items: center;
    font-size: 12px;
  }

  .emptyList {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 40vh;

    > div {
      text-align: center;
      color: #bbb;

      .ic {
        font-size: 32px;
      }

      h5 {
        margin-top: 0.5rem;
      }
    }
  }
}

.form-actions.row {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  margin-top: 2rem;

  .btn {
    min-width: 100px;
  }
}
</style>